module.exports = __webpack_public_path__ + "img/64800.0cd156e1.jpg";